'use client'

import { useInbox } from './InboxProvider'
import { InboxItemCard } from './inbox-item-card'
import { Skeleton } from '@/ui/skeleton'

export function InboxList() {
  const { items, loading, markRead, actOn } = useInbox()

  if (loading) {
    return (
      <div className="space-y-3">
        <Skeleton className="h-20 w-full" />
        <Skeleton className="h-20 w-full" />
        <Skeleton className="h-20 w-full" />
      </div>
    )
  }

  if (items.length === 0) {
    return (
      <div className="py-16 text-center">
        <p className="text-muted-foreground text-sm">No notifications</p>
      </div>
    )
  }

  // Sort: unread first, then read
  const sorted = [...items].sort((a, b) => {
    if (a.status === 'unread' && b.status !== 'unread') return -1
    if (a.status !== 'unread' && b.status === 'unread') return 1
    return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  })

  return (
    <div className="space-y-2">
      {sorted.map((item) => (
        <InboxItemCard
          key={item.id}
          item={item}
          onMarkRead={markRead}
          onAct={actOn}
        />
      ))}
    </div>
  )
}
